import { render, staticRenderFns } from "./MicrosoftCallback.vue?vue&type=template&id=3f43ccb3&scoped=true&"
import script from "./MicrosoftCallback.vue?vue&type=script&lang=js&"
export * from "./MicrosoftCallback.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftCallback.vue?vue&type=style&index=0&id=3f43ccb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43ccb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VProgressCircular,VRow})
